// removed by extract-text-webpack-plugin
module.exports = {"zIndex":"tarifas__zIndex___1UQtb","text_xs":"tarifas__text_xs___1lRYC","bgGray":"tarifas__bgGray___ck0_F"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/api/tarifa/tarifas.css
// module id = 1157
// module chunks = 0